<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand to="/">Commonwealth Moisture and Mold</b-navbar-brand>

      <b-navbar-toggle target="nav_collapse"/>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item to="/">Home</b-nav-item>
          <b-nav-item to="testing">Testing</b-nav-item>
          <b-nav-item to="moldandmildew">Mold &amp; Mildew</b-nav-item>
          <b-nav-item to="crawlspaces">Crawlspaces &amp; Basements</b-nav-item>
          <b-nav-item to="hvac">HVAC Duct Cleaning</b-nav-item>
          <b-nav-item to="about">About Us</b-nav-item>
          <b-nav-item to="contact">Contact Us</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {};
</script>

<style>
.router-link-exact-active {
  color: white !important;
}
</style>
